import clsx from 'clsx';

type Props = {
  message: string;
  variant?: 'success' | 'error';
};

const SaveToast = ({ message, variant = 'success' }: Props) => (
  <div
    role="status"
    aria-live="polite"
    className={clsx(
      'fixed bottom-36 left-1/2 z-100 -translate-x-1/2 rounded-lg px-4 py-3 text-sm font-medium text-white shadow-paper',
      variant === 'error' ? 'bg-error-700' : 'bg-success-700'
    )}>
    {message}
  </div>
);

export default SaveToast;
